module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Ennetbaden-708594cafabada50f725f5cd3ef393b1.svg";